module.exports = __webpack_public_path__ + "img/uploadFile.538213d2.png";